module.exports = __webpack_public_path__ + "static/media/DqEveryChildOfflineToys.8aa6abd3.jpg";